"use client"

import { motion } from "framer-motion"
import { CheckCircle } from "lucide-react"
import Image from "next/image"

export default function AboutSection() {

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  }

  const benefits = [
    "Strategic storytelling that engages stakeholders",
    "Award-winning design that enhances your brand",
    "Data visualization that simplifies complex information",
    "Comprehensive service from concept to delivery",
  ]

  return (
    <section
      className="md:px-28 bg-gradient-tob from-white to-gray-50 relative overflow-hidden space-y-20"
      id="about"
    >

      <div className="container mx-auto px-4 relative z-10">

        <motion.div
          initial="visible"
          variants={containerVariants}
          className="text-center mb-10 md:mb-16"
        >
          {/* <motion.span
            variants={itemVariants}
            className="inline-block mb-3 md:mb-4 px-4 py-2 rounded-full bg-gray-200 text-gray-800 font-medium text-sm"
          >
            About Us
          </motion.span> */}

          <motion.h2
            variants={itemVariants}
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4"
          >
            {/* Designing Reports with Purpose & Precision */}
            About Us
          </motion.h2>

          <motion.p variants={itemVariants} className="text-base md:text-lg text-gray-600 max-w-4xl mx-auto">
            At Annual ESG, we specialise in transforming data into impactful visual stories. With a passion for design and a
            commitment to clarity, our team delivers high-quality reports. The result: Sustainability & Annual reports that comply, connect and
            persuade.
          </motion.p>
        </motion.div>



        <motion.div
          // initial="hidden"
          variants={containerVariants}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
        >
          {/* Left Column - Image */}
          <motion.div variants={itemVariants} className="relative">
            <div className="relative max-h-[520px] rounded-2xl overflow-hidden shadow2xl borde flex items-center justify-center">

              <Image
                src="https://whitebunnie.com/wp-content/uploads/2024/10/whyChooseUs-2-1.png"
                // src={integrated}
                alt="About Annual ESG"
                width={480}
                height={480}
                className="rounded-2xl overflow-hidden shadow2xl borde flex items-center justify-center"
              />


            </div>


          </motion.div>

          {/* Right Column - Content */}
          <motion.div variants={containerVariants} className="space-y-6">

            <motion.h2 variants={itemVariants} className="text-xl md:text-3xl font-bold text-primary mb-6">
              <span className="text-gradient">Who We Are-Annual ESG</span>
            </motion.h2>

            <motion.p variants={itemVariants} className="text-lg text-gray-600">
              Annual ESG is a corporate
              report design company and
              serving clients worldwide.
              Our multidisciplinary team
              blends subject matter
              fluency, award-winning
              design, and data-engineering
              know-how. The result: reports
              that comply, compel, and
              insightful.
            </motion.p>


            <motion.div variants={itemVariants} className="pt-4">
              <ul className="space-y-3">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start">
                    <CheckCircle className="text-accent mr-3 mt-1 flex-shrink-0 w-5 h-5" />
                    <span className="text-gray-700">{benefit}</span>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* <motion.div variants={itemVariants} className="pt-0">
              <button className="premium-button">Learn More</button>
            </motion.div> */}

          </motion.div>
        </motion.div>
      </div>



    </section>
  )
}
